import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Down = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Down' {...props}>
    <polyline fill='none' stroke='#000' strokeWidth='2' points='7.086 3.174 17.086 13.174 7.086 23.174' transform='scale(1 -1) rotate(-89 -1.32 0)' />
  </StyledIcon>
);
